import { CodeStub } from '@icure/cardinal-sdk'

export const getPreparedTagsToUpdatePatient = (tags: string[]) => {
  const getTags = () => {
    return (tags ?? []).map((tag) => {
      const tagType = 'RETINO_BRIDGE'
      const tagVersion = '1'

      return new CodeStub({
        id: `${tagType}|${tag}|${tagVersion}`,
        type: tagType,
        code: tag,
        version: tagVersion,
      })
    })
  }

  return {
    tags: getTags(),
  }
}
